import gql from 'graphql-tag'

export const SEARCH_USER_EMAIL_QUERY = gql`
  query($email: String) {
    searchUserEmail: allUsers(filter: { email: $email }) {
      email
    }
  }
`
